<template>
	<div class="Internet-plc">
		<div class="box-1">
			<h3>PLC</h3>
			<p>
				{{ $t("PLC.PLCLabel") }}
			</p>
			<img src="../../assets/imgs/PLC-1.png" alt="" />
		</div>
		<div class="box-2">
			<img src="../../assets/imgs/PLC-2.png" alt="" />
			<div>
				<h3>{{ $t("PLC.supports") }}</h3>
				<p>
					{{ $t("PLC.IIoT") }}
				</p>
				<ul class="box-2-list">
					<li>
						FL3-2G
					</li>
					<li>
						FL3-4G
					</li>
					<li>
						FL3-WIFI
					</li>
				</ul>
			</div>
		</div>
		<div class="box-2">
			<div>
				<h3>{{ $t("PLC.Hidden") }}</h3>
				<p>
					{{ $t("PLC.dedicated") }}
				</p>
			</div>
			<img src="../../assets/imgs/PLC-4.png" alt="" />
		</div>
		<div class="box-1">
			<h3>{{ $t("PLC.Edge") }}</h3>
			<p>
				{{ $t("PLC.module") }}
			</p>
			<img src="../../assets/imgs/PLC-6.png" alt="" />
		</div>
	</div>
</template>
<script>
export default {
	data() {
		return {
			plcList: [
				{
					url: require("../../assets/imgs/test.png"),
					label: this.$t("PLC.view"),
				},
				{
					url: require("../../assets/imgs/update.png"),
					label: this.$t("PLC.state"),
				},
				{
					url: require("../../assets/imgs/service.png"),
					label: this.$t("PLC.statistics"),
				},
				{
					url: require("../../assets/imgs/operation.png"),
					label: this.$t("PLC.analysis"),
				},
			],
		};
	},
};
</script>
<style lang="scss">
.Internet-plc {
	.box-1 {
		text-align: center;
		padding: 40px 0;
		p {
			margin-bottom: 50px;
		}
	}
	.box-2 {
		display: flex;
		justify-content: center;
		margin: 120px 0;
		align-items: center;
		> div {
			width: 656px;
			display: flex;
			flex-direction: column;
			padding: 0 40px;
			p {
				font-size: 16px;
				line-height: 30px;
				color: #666666;
				margin-bottom: 40px;
			}
			.box-2-list {
				display: flex;
				flex: 1;
				li {
					margin-right: 40px;
				}
			}
		}
	}
	.box-3 {
		width: 1200px;
		margin: 0 auto;
		.box-2-list2 {
			display: flex;
			justify-content: space-between;
			align-content: center;
			line-height: 55px;
			width: 515px;
			color: #666666;
			margin-bottom: 40px;
			flex-direction: row;
		}
		h3 {
			text-align: left;
		}
		p {
			margin-bottom: 50px;
		}
	}
	h3 {
		font-size: 48px;
		text-align: center;
		font-weight: inherit;
		margin-bottom: 38px;
	}
}
</style>
